export default "__VITE_ASSET__CYlLqRIn__"